import React, { useState } from 'react'
import CommunityList from './CommunityList'
import CommunityDetailMain from './CommunityDetail/CommunityDetailMain'
import AddCommunityLeadPersonalMain from './AddEditCommunityLead/Main'

import BackLogo from '../../../../../images/rewampimages/Chevron.png'

import AddDealer from './AddEditDealerNew/Main'
export default function CommunityMain({ pageViewHandler }) {
    const [salesAgentView, setSalesAgentView] = useState("list")
  const [tab, setTab] = useState("list")
  const [data, setData] = useState("")

  const handlePage = (value, pageType) => {
    setData(value)
    setTimeout(() => {

      setTab(pageType)
    }, 200)
  }

  const handleBack = (e) => {
    if (tab === "list") {
      pageViewHandler(e, 'landingPage')
    } else if (tab === "detail" && salesAgentView == "list") {
      handlePage("", "list")
    }
  }


  const handleSaleAgentView = (type) => {
    setSalesAgentView(type)
}

  return (
    <>
      {
        ((tab == "list" || tab == "detail") && salesAgentView == "list") ?
          <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '15px' }} onClick={(e) => handleBack(e)}>
            <img src={BackLogo} alt="" width={'35%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
            <h5 style={{ cursor: 'pointer' }}>Back</h5>
          </div>
          : ''}

      <div className="communitySection" style={{ marginTop: '20px' }}>
        {
          tab === "list" ?
            <CommunityList handlePage={handlePage} />
            : ''}
        {
          tab === "detail" ?
            <CommunityDetailMain Detaildata={data} handlePage={handlePage} handleSaleAgentView={handleSaleAgentView} salesAgentView={salesAgentView}/>
            : ''}

        {
          tab === "addcommunityLeadMain" ?
            <AddCommunityLeadPersonalMain Pagedata={data} handlePage={handlePage} />
            : ''}

        {
          tab === "addEditDealer" ?
            <AddDealer Detaildata={data} handlePage={handlePage} />
            : ''}

      </div>
    </>
  )
}
